import { getRailsClient } from "../client/railsClient";
import { retrieveTenantList } from "../utils/authService";

const AvailableTenantsRoute = "/api/internal_api/atlas/tenants/get_tenant_names";

export type AvailableTenant = {
  name: string;
  display_name: string;
  id: string;
};

export const fetchAvailableTenants = async (): Promise<AvailableTenant[]> => {
  const railsClient = getRailsClient();
  try {
    const { data } = await railsClient.get<{ tenants: AvailableTenant[] }>(AvailableTenantsRoute);
    return data.tenants;
  } catch {
    const tenants = await retrieveTenantList();

    return tenants.map((tenant: string) => ({
      name: tenant,
      display_name: tenant,
      id: tenant,
    }));
  }
};
